import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import themeConfig from './themeConfig'
import CssBaseline from '@mui/material/CssBaseline'
import PropTypes from 'prop-types'

// see https://mui.com/material-ui/customization/theming/

export const Theme = ({ children }) => {
  return (
    <>
      <CssBaseline />
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={themeConfig}>{children}</ThemeProvider>
      </StyledEngineProvider>
    </>
  )
}

Theme.propTypes = {
  children: PropTypes.any
}
